import React from 'react';
import classnames from 'classnames';
import { IsiArrow } from './arrow';
import useTranslation from '../../../../hooks/useTranslation';

const IsiHeader: React.FC<{
	toggled: boolean;
	onClick: React.MouseEventHandler<HTMLButtonElement>;
}> = ({ toggled, onClick }) => {
	const { t } = useTranslation();
	return (
		<div className="h-8 w-full mx-auto max-w-6xl mx-auto flex justify-end items-center">
			<button onClick={onClick} aria-label={t('pages.footer.isi.title')}>
				<div className="flex items-center py-1 px-3 focus:outline-none">
					<p className="text-brand font-semibold">
						{toggled
							? t('pages.footer.isi.viewLess')
							: t('pages.footer.isi.viewMore')
						}
					</p>
					<div className="pl-2">
						<IsiArrow
							className={classnames('fill-brand', {
								'rotate-180': !toggled,
							})}
						/>
					</div>
				</div>
			</button>
		</div>
	);
};

export default IsiHeader;
